import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-image',
  templateUrl: './loader-image.component.html',
  styleUrls: ['./loader-image.component.css']
})
export class LoaderImageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/loaders/loader-image/loader-image.component.ts